import {OPEN_RESA} from "../actions/booking.action";

const initialState = {};

export default function bookingReducer(state = initialState, action) {
  switch (action.type) {
  case OPEN_RESA:
    return action.payload;
  default:
    return state;
  }
}